import * as geoInspects from '@arcgis/core/geometry/operators/intersectsOperator';
import * as goeProjection from '@arcgis/core/geometry/projection';
import GraphicsLayer from '@arcgis/core/layers/GraphicsLayer';
import SketchViewModel from '@arcgis/core/widgets/Sketch/SketchViewModel'
import '@esri/calcite-components/dist/components/calcite-action-group';
import mapUtils from '@/utils/map-utils';
import PoleItem from '@/utils/pole-item';

// 定数
const LOGH = 'BFA10104G map range:';

//
// 範囲選択モデル作成
//
export function rangeSelectSketchModel(view) {
  const layer = new GraphicsLayer({ title: "選択描画" });
  const sketch = new SketchViewModel({
    view: view,
    layer: layer,

    // 選択モード継続
    creationMode: 'continuous',

    // 未使用と思われる設定を無効化
    updateOnGraphicClick: false,
    highlightOptions: { enabled: false },
    snappingOptions: { enabled: false },
  });
  return sketch;
}

/**
 * 範囲選択イベント処理
 */
export function rangeSelectHandler({
    event,
    sketch, layers,
    propValues, setSelectMode
}) {
  const { itemSelected, onItemSelect, onPoleListSelect } = propValues.current;

  // 選択開始
  if (event.state === 'start') {
    console.info(LOGH, '範囲選択開始');

    // 現在の選択電柱/径間を解除
    itemSelected && onItemSelect(null);
    return;
  }

  // 選択終了
  if (event.state === 'complete') {
    rangeSelectComplete({ event, sketch, layers, onPoleListSelect });
    return;
  }

  // 選択取消
  if (event.state === 'cancel') {
    console.info(LOGH, '範囲選択取消');
    setSelectMode(null);
  }
}

//
// 範囲選択確定
//
async function rangeSelectComplete({ event, sketch, layers, onPoleListSelect }) {

  // 座標系変換
  // NOTE: projection は deprecated だが、後継の projectOperator が
  //       Uncaught TypeError: i is not a function エラーになるので...
  const geometry = goeProjection.project(
      event.graphic.geometry,
      layers.pole.spatialReference);

  // 電柱一覧/設備一覧を検索
  const items = [
    ...layers.pole.graphics.items,
    ...layers.setubi.graphics.items,
  ];
  const rangeItems = items
      .filter((g) => geoInspects.execute(g.geometry, geometry))
      .map((g) => new PoleItem(g.attributes.pole));

  // 電柱マスタを検索
  const masters = await rangeSelectFromMaster({ event, layers });
  rangeItems.push(...masters);

  // 一覧のソートと重複除去
  const poles = [];
  rangeItems
      .sort(PoleItem.compare)
      .forEach((pole) => {
        const last = poles.at(-1);
        if (!pole.same(last)) {
          poles.push(pole);
        }
      });
  console.info(LOGH, '範囲選択終了', `${poles.length}件`);

  // 選択枠をクリア
  sketch.layer.removeAll();

  // 何も選択してなければ終了
  if (poles.length === 0) {
    console.info(LOGH, '範囲選択終了 0件');
    return;
  }

  // 電柱一覧更新
  const max = 100;
  const warnings = [];
  if (poles.length > max) {
    poles.length = max;
    warnings.push({ id: 'BFY000015W', values: [ max ] });
  }
  onPoleListSelect(poles, warnings);
}

//
// 電柱マスタ範囲検索
//
async function rangeSelectFromMaster({ event, layers }) {
  const masterView = layers.masterView;
  if (!masterView) return [];

  // 電柱マスタを検索
  const query = masterView.createQuery();
  query.geometry = event.graphic.geometry;
  const result = await masterView.queryFeatures(query);

  // 電柱一覧に変換
  return result.features
      .map((feature) => feature.attributes)
      .filter((pole) => pole?.areaCode && pole?.lineCode && pole?.poleNo)
      .map((pole) => new PoleItem(pole));
}
